import React, { useState } from 'react';
import {
  Collapse,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useIntl } from 'react-intl';

import moment from 'moment';

import { SHeadTableCell } from '../../../../components/styledComponents/Tables';
import { ColorButton } from '../../../../components/other/Buttons';
import { orderTypeList } from '../constatns';
import { ViewMode } from '../OrderPage';
import { IUser } from '../../../../interfaces/user';
import { IOrder, IOrderType } from '../../../../interfaces/order';
import { useStyles } from '../hooks/useStyles';
import { useDefineUserRole } from '../../../../hooks';
import { Payment } from './Payment';
import { thousands } from '../../../../utils/utils';

const getStatusString = (type: string, selectedOrderStatuses: string[]): string => {
  if (type === 'full') {
    if (selectedOrderStatuses.length > 0) {
      return selectedOrderStatuses.toString();
    }
    return orderTypeList.toString();
  }
  if (type === 'abandoned') return 'cart';
  return '';
};
type TProps = {
  item: IOrder;
  me?: IUser;
  type: string;
  selectAction: (id: any) => void;
  selectActionPaid: (id: any) => void;
  editStatus: (id: any) => void;
  handleDeleteDialog: (id: number | undefined) => void;
  editAction: (item: any, mode: any) => void;
  selectedOrderStatuses: string[];
  selectedPaidOrderStatuses: string[];
  selectedId: number;
  selectedPaidId: number;
  isBuyer: boolean;
  translates: { [p: string]: string };
  translatesStatus: { [p: string]: string };
  page: number;
  perPage: number;
  userId: number | undefined;
  orderTypes: IOrderType[];
  orderStatusTypes: IOrderType[];
};
const TableRowOrderList: React.FC<TProps> = ({
  item,
  me,
  type,
  selectAction,
  handleDeleteDialog,
  editAction,
  selectedOrderStatuses,
  selectedId,
  isBuyer,
  translates,
  translatesStatus,
  editStatus,
  page,
  perPage,
  userId,
  orderTypes,
  orderStatusTypes,
  selectedPaidId,
  selectActionPaid,
}) => {
  const classes1 = useStyles();
  const { classes } = classes1;
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);
  const [showPayment, setShowPayment] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState<{
    type: 'buyer' | 'seller';
    order: IOrder;
  }>({} as any);

  const openPayment = (type: 'buyer' | 'seller', order: IOrder) => {
    setPaymentInfo({ type, order });
    setShowPayment(true);
  };

  const isOpen = me?.is_admin && (item?.orders?.length ?? 0) > 0;
  return (
    <>
      <TableRow key={item.id}>
        <TableCell
          className={classes.cellItem}
          onClick={() => isOpen && setOpen(!open)}
          align='left'
        >
          {item.id || '-'}{' '}
          {me?.is_admin && (item?.orders?.length ?? 0) > 0 ? (
            <IconButton aria-label='expand row' size='small'>
              {open ? (
                <KeyboardArrowUpIcon fontSize='large' />
              ) : (
                <KeyboardArrowDownIcon fontSize='large' />
              )}
            </IconButton>
          ) : null}
        </TableCell>
        <TableCell
          onClick={() => isOpen && setOpen(!open)}
          className={classes.cellItem}
          align='left'
        >
          {item.checkout_at ? moment(item.checkout_at).format('HH:mm DD.MM.YY') : ''}
        </TableCell>
        {isBuyer && (
          <TableCell className={classes.cellItem} align='left'>
            {item.goods_num || ''}
          </TableCell>
        )}
        {me?.is_admin && (
          <>
            <TableCell
              onClick={() => isOpen && setOpen(!open)}
              className={classes.cellItem}
              align='left'
            >
              {item.buyer_company?.brand || ''}
            </TableCell>
          </>
        )}
        {!isVendor && (
          <TableCell className={classes.cellItem} align='right'>
            {thousands(String(item.summ || ''))} р.
            <ColorButton
              className={classes.colorButtonIconView}
              color='#006997'
              onClick={() => openPayment('buyer', item)}
              title={intl.formatMessage({ id: 'ORDER.VIEW' })}
            >
              <VisibilityIcon htmlColor='#fff' />
            </ColorButton>
          </TableCell>
        )}
        <TableCell className={classes.cellItem} align='left'>
          {selectedPaidId !== item.id ? (
            <ColorButton
              color='#a3a7b84c'
              onClick={() => selectActionPaid(item.id)}
              disable={!me?.is_admin}
              className={classes.colorButton}
            >
              {translatesStatus[item.payment_status]}
            </ColorButton>
          ) : (
            <TextField
              select
              margin='normal'
              value={item.payment_status}
              onChange={event => {
                editStatus({
                  id: item.id,
                  page,
                  perPage,
                  statuses: getStatusString(type, selectedOrderStatuses),
                  data: {
                    payment_status: event.target.value,
                  },
                  userId,
                  root: me?.is_admin,
                });
                selectActionPaid(-1);
              }}
              variant='outlined'
              className={classes.typeList}
              size='small'
            >
              {orderStatusTypes &&
                orderStatusTypes.map(option => (
                  <MenuItem key={option.type} value={option.type}>
                    {option.translate}
                  </MenuItem>
                ))}
            </TextField>
          )}
        </TableCell>
        {isVendor && (
          <TableCell
            onClick={() => isOpen && setOpen(!open)}
            className={classes.cellItem}
            align='right'
          >
            {thousands(String(item.vendor_summ || ''))} р.
            <ColorButton
              className={classes.colorButtonIconView}
              color='#006997'
              onClick={() => openPayment('seller', item)}
              title={intl.formatMessage({ id: 'ORDER.VIEW' })}
            >
              <VisibilityIcon htmlColor='#fff' />
            </ColorButton>
          </TableCell>
        )}
        {/* {!isVendor && !isBuyer && (
          <TableCell onClick={() => isOpen && setOpen(!open)} className={classes.cell} />
        )} */}
        <TableCell className={classes.cellItem} align='left'>
          {selectedId !== item.id ? (
            <ColorButton
              color='#a3a7b84c'
              onClick={() => selectAction(item.id)}
              disable={!me?.is_admin}
              className={classes.colorButton}
            >
              {translates[item.status]}
            </ColorButton>
          ) : (
            <TextField
              select
              margin='normal'
              value={item.status}
              onChange={event => {
                editStatus({
                  id: item.id,
                  page,
                  perPage,
                  statuses: getStatusString(type, selectedOrderStatuses),
                  data: { status: event.target.value },
                  userId,
                  root: me?.is_admin,
                });
                selectAction(-1);
              }}
              variant='outlined'
              className={classes.typeList}
              size='small'
            >
              {orderTypes &&
                orderTypes.map(option => (
                  <MenuItem key={option.type} value={option.type}>
                    {option.translate}
                  </MenuItem>
                ))}
            </TextField>
          )}
        </TableCell>
        <TableCell className={classes.cellItem} align='right' width={150}>
          <ColorButton
            className={classes.colorButtonIconView}
            color='#006997'
            onClick={() => editAction(item, ViewMode.VIEW)}
            title={intl.formatMessage({ id: 'ORDER.VIEW' })}
          >
            <VisibilityIcon htmlColor='#fff' />
          </ColorButton>

          {me?.is_admin && (
            <ColorButton
              className={classes.colorButtonIconView}
              color='#006997'
              onClick={() => editAction(item, ViewMode.EDIT)}
              title={intl.formatMessage({ id: 'ORDER.EDIT' })}
            >
              <EditIcon htmlColor='#fff' />
            </ColorButton>
          )}

          {!isBuyer && (
            <ColorButton
              className={classes.colorButtonIconView}
              color='#d01c1f33'
              onClick={() => handleDeleteDialog(item.id)}
              title={intl.formatMessage({ id: 'ORDER.DELETE' })}
            >
              <DeleteIcon htmlColor='#d01c1f' />
            </ColorButton>
          )}
        </TableCell>
      </TableRow>
      <TableRow className={classes.subTableRow}>
        <TableCell style={{ padding: 0 }} colSpan={9}>
          <Collapse in={open} timeout='auto' unmountOnExit>
            <Table size='small' aria-label='purchases'>
              <TableHead>
                <TableRow>
                  <SHeadTableCell className={classes.cell} align='left'>
                    {intl.formatMessage({ id: 'ORDER.TABLE.ID' })}
                  </SHeadTableCell>
                  <SHeadTableCell className={classes.cell} align='left'>
                    {intl.formatMessage({ id: 'USER.ROLES.VENDOR' })}
                  </SHeadTableCell>
                  <SHeadTableCell className={classes.cell} align='right' width={250}>
                    {intl.formatMessage({ id: 'PROVIDER.BILL' })}
                  </SHeadTableCell>
                  <SHeadTableCell className={classes.cell} align='left'>
                    {intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS' })}
                  </SHeadTableCell>
                  <SHeadTableCell className={classes.cell} />
                </TableRow>
              </TableHead>
              <TableBody>
                {item?.orders?.map(orderItem => (
                  <TableRow key={orderItem.id}>
                    <TableCell align='left' className={classes.cell}>
                      {orderItem.id || '-'}
                    </TableCell>
                    <TableCell className={classes.cell} align='left'>
                      {orderItem.company?.brand || ''}
                    </TableCell>
                    <TableCell className={classes.cell} align='right'>
                      {thousands(String(orderItem.vendor_summ || ''))} р.
                      <ColorButton
                        className={classes.colorButtonIconView}
                        color='#006997'
                        onClick={() => openPayment('seller', orderItem)}
                        title={intl.formatMessage({ id: 'ORDER.VIEW' })}
                      >
                        <VisibilityIcon htmlColor='#fff' />
                      </ColorButton>
                    </TableCell>
                    <TableCell className={classes.cell} align='left'>
                      {selectedPaidId !== orderItem.id ? (
                        <ColorButton
                          color='#a3a7b84c'
                          onClick={() => selectActionPaid(orderItem.id)}
                          disable={!me?.is_admin}
                          className={classes.colorButton}
                        >
                          {translatesStatus[orderItem.payment_status]}
                        </ColorButton>
                      ) : (
                        <TextField
                          select
                          margin='normal'
                          value={orderItem.payment_status}
                          onChange={event => {
                            editStatus({
                              id: orderItem.id,
                              page,
                              perPage,
                              statuses: getStatusString(type, selectedOrderStatuses),
                              data: {
                                payment_status: event.target.value,
                              },
                              userId,
                              root: me?.is_admin,
                            });
                            selectActionPaid(-1);
                          }}
                          variant='outlined'
                          className={classes.typeList}
                          size='small'
                        >
                          {orderStatusTypes &&
                            orderStatusTypes.map(option => (
                              <MenuItem key={option.type} value={option.type}>
                                {option.translate}
                              </MenuItem>
                            ))}
                        </TextField>
                      )}
                    </TableCell>
                    <TableCell className={classes.cell} align='right' width={150}>
                      <ColorButton
                        className={classes.colorButtonIconView}
                        color='#006997'
                        onClick={() => editAction(orderItem, ViewMode.VIEW)}
                        title={intl.formatMessage({ id: 'ORDER.VIEW' })}
                      >
                        <VisibilityIcon htmlColor='#fff' />
                      </ColorButton>

                      {me?.is_admin && (
                        <>
                          <ColorButton
                            className={classes.colorButtonIconView}
                            color='#006997'
                            onClick={() => editAction(orderItem, ViewMode.EDIT)}
                            title={intl.formatMessage({ id: 'ORDER.EDIT' })}
                          >
                            <EditIcon htmlColor='#fff' />
                          </ColorButton>

                          <ColorButton
                            className={classes.colorButtonIconView}
                            color='#d01c1f33'
                            onClick={() => handleDeleteDialog(orderItem.id)}
                            title={intl.formatMessage({ id: 'ORDER.DELETE' })}
                          >
                            <DeleteIcon htmlColor='#d01c1f' />
                          </ColorButton>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>

      <Payment
        open={showPayment}
        handleClose={() => {
          setShowPayment(false);
          setPaymentInfo({} as any);
        }}
        order={paymentInfo.order}
        type={paymentInfo.type}
      />
    </>
  );
};

export default React.memo(TableRowOrderList);
